import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  typography: {
    h1: {
      fontSize: "clamp(1.5rem, 3vw, 1.75rem)",
      fontWeight: 700,
      lineHeight: 1.3,
      letterSpacing: "-0.04em",
    },
    subtitle1: {
      fontWeight: 700,
    },
    body1: {
      fontSize: "0.875rem",
    },
  },
  palette: {
    primary: {
      main: "#EC002F",
      dark: "#D4002A",
      contrastText: "#FFFFFF",
      light: "#ffa5b869",
    },
    secondary: {
      main: "#FFFFFF",
      light: "#FFF7F9",
      contrastText: "#17211B",
    },
    text: {
      primary: "#111",
      secondary: "#475569",
    },
    background: {
      paper: "#FFFFFF",
    },
    action: {
      disabled: "#C9C9C9",
    },
    info: {
      main: "#dedede",
      light: "#f6f6f6",
      dark: "#94A3B8",
    },
    warning: {
      main: "#ffb21a",
      light: "#47d7a0",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 30,
        },
        outlined: ({ theme }) => ({
          color: theme.palette.secondary.contrastText,
        }),
      },
    },
  },
});
